<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div fxLayout="column" id="recordContainer" fxLayoutGap="8px">
  <div *ngFor="let record of recordData; let i = index">
    <div fxLayout="row" class="record-title-container">
      <button mat-icon-button class="toggle-button" (click)="toggleCollapse(i)">
        <fa-icon
          class="icon"
          [icon]="collapsedStates[i] ? faChevronRight : faChevronDown"
        ></fa-icon>
      </button>
      <record-title
        class="record-title"
        [itemIcon]="record.itemIcon"
        [title]="record.itemName"
        [timestamp]="record.timestamp"
      ></record-title>
    </div>
    <div [ngClass]="{ collapsed: collapsedStates[i] }" class="record-content">
      <div fxLayout="column" class="record-padding">
        <div [ngSwitch]="record.itemType">
          <div *ngSwitchCase="WorkflowItemType.QUESTION">
            <question-record [record]="record?.itemData"></question-record>
          </div>
          <div *ngSwitchCase="WorkflowItemType.CAMERA">
            <camera-record [record]="record?.itemData"></camera-record>
          </div>
          <div *ngSwitchCase="WorkflowItemType.SIGNATURE">
            <signature-record [record]="record?.itemData"></signature-record>
          </div>
          <div *ngSwitchCase="WorkflowItemType.SCANNER">
            <scanner-record [record]="record?.itemData"></scanner-record>
          </div>
          <div *ngSwitchCase="WorkflowItemType.FORM" [ngSwitch]="record.itemSubtype">
            <div *ngSwitchCase="WorkflowItemSubtype.INFO">
              <info-record [record]="record?.itemData"></info-record>
            </div>
            <div *ngSwitchCase="WorkflowItemSubtype.INPUT">
              <input-record [record]="record?.itemData"></input-record>
            </div>
            <div *ngSwitchCase="WorkflowItemSubtype.CHECKLIST">
              <checklist-record [record]="record?.itemData"></checklist-record>
            </div>
            <div *ngSwitchCase="WorkflowItemSubtype.UNKNOWN">
              <form-record [record]="record?.itemData"></form-record>
            </div>
          </div>
          <div *ngSwitchCase="WorkflowItemType.UNKNOWN">
            <unknown-record [record]="record?.itemData"></unknown-record>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="taskEndTimeStamp" fxLayout="row" class="record-title-container">
    <div class="finished-icon" fxLayoutAlign="center center">
      <fa-icon class="icon" [icon]="faCheck"></fa-icon>
    </div>
    <record-title
      class="record-title"
      [title]="FINISHED_STRING"
      [timestamp]="taskEndTimeStamp"
    ></record-title>
  </div>
</div>
